
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IHinhThucThi } from "../../../model/respone/tct/IHinhThucThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHinhThucThiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IHinhThucThi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IHinhThucThi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IHinhThucThi,
    SAVE_SUCCESS: {} as IHinhThucThi,
    SAVE_ERROR: "",

    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[]
};
export const eHinhThucThiActionIds = generateActionTypeIds(
    eHinhThucThiActionsObj,
    "HINH_THUC_THI"
);
export type IHinhThucThiActionTypes = IGenericActionType<
    typeof eHinhThucThiActionsObj,
    "HINH_THUC_THI"
>;
